/**
 * Reset único por valor: ao publicar uma versão que exige limpar IndexedDB e forçar novo login,
 * defina aqui a mesma string de versão do `package.json` (após `setVersion` no build, se aplicável).
 *
 * - Deixe `''` para desligar (nenhum reset automático).
 * - Usuários em build **anterior** a esta versão não resetam até atualizarem o app.
 * - Depois do reset, gravamos o valor aplicado; para um novo reset em outro release, altere
 *   esta string de novo (ex.: de `'1.3.80'` para `'1.4.0'`).
 *
 * `cart_details` fica no IndexedDB `pwa_rca_carts` (não apagado no reset). Correlatas (`cart_id`, etc.) em localStorage — ver `maybeApplyForcedCacheReset`.
 */
export const FORCE_CACHE_RESET_AT_VERSION = '1.4.131';
